import { useCore } from 'contexts/core';
import { useEffect } from 'react';
import { fetchProducts } from 'products/fetchProducts';
import { usePlannerConfig } from 'contexts/plannerConfig';
import { useServiceSettings } from 'contexts/serviceSettings';
import { e2e, getQuery } from 'utils/queryUtils';
import { useAppDispatch } from 'ducks/hooks';
import { isProduction } from '../utils/platform';

const Debugger = ({ children }: any) => {
  const core = useCore();
  const dispatch = useAppDispatch();
  const { kompisSettings, dexfSettings, translations } = useServiceSettings();
  const { plannerConfig } = usePlannerConfig();

  useEffect(() => {
    // only async load debug chunk if envvar is set or app is started from e2e tests. Prevents bloat in production build!
    if (getQuery().get('disableDebug') !== 'true' && (!isProduction() || e2e())) {
      import('./PlannerDebug').then(PlannerDebug =>
        PlannerDebug.installDebug(core, dispatch, plannerConfig, () => {
          fetchProducts(kompisSettings, dexfSettings, translations, { ...plannerConfig }, dispatch);
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
};

export default Debugger;
